module.exports = __webpack_public_path__ + "img/eg5.09ece8cf.png";